export const projects = [
  {
    id: '1',
    image: require('../assets/netflix-preview.png'),
    title: 'Netflix Clone',
    description: 'This project was developed with JavaScript using the ReactJs library, and a project that copies the main Netflix interface, but it is not functional, it was only reproduced the front end, which is responsive.',
    github_link: 'https://github.com/DAVI-REZENDE/clones-with-react/tree/main/netflix-clone',
    deploy_link: 'https://netflix-interface-clone.netlify.app',
    tags: [
      {
        id: '1',
        name: 'ReactJS',
      },
      {
        id: '2',
        name: 'Material UI',
      },
      {
        id: '3',
        name: 'TypeScript'
      }
    ]
  },

  {
    id: '2',
    image: require('../assets/dropbox-preview.png'),
    title: 'Dropbox Clone',
    description: 'This project was developed in ReactJS, and its objective is to reproduce the functionality of the header Dropbox and side menu.',
    github_link: 'https://github.com/DAVI-REZENDE/clones-with-react/tree/main/dropbox-clone',
    deploy_link: 'https://dropbox-clone-interface.netlify.app/',
    tags: [
      {
        id: '1',
        name: 'ReactJS',
      },
      {
        id: '2',
        name: 'Styled Components',
      },
      {
        id: '3',
        name: 'React Icons',
      },
      {
        id: '4',
        name: 'TypeScript',
      }
    ]
  },

  {
    id: '3',
    image: require('../assets/github-preview.png'),
    title: 'Clone of the main Github interface',
    description: 'This project was done with the official REST API of github, with the objective of recreating a users profile, in the header input you can write your username to view your profile. If you click on the logo the site theme is changed.',
    github_link: 'https://github.com/DAVI-REZENDE/clones-with-react/tree/main/github-clone',
    deploy_link: 'https://github-interface-clone.netlify.app/',
    tags: [
      {
        id: '1',
        name: 'ReactJS',
      },
      {
        id: '2',
        name: 'Styled Components',
      },
      {
        id: '3',
        name: 'React Calendar Heatmap',
      },
      {
        id: '4',
        name: 'TypeScript',
      },
      {
        id: '5',
        name: 'React Router Dom',
      }
    ]
  },
  {
    id: '4',
    image: require('../assets/discord-preview.png'),
    title: 'Clone of the main Discord interface',
    description: 'This project was developed with ReactJS, in order to recreate Discord main interface.',
    github_link: 'https://github.com/DAVI-REZENDE/clones-with-react/tree/main/discord-interface-clone',
    deploy_link: 'https://discordcloneinterface.netlify.app/',
    tags: [
      {
        id: '1',
        name: 'ReactJS',
      },
      {
        id: '2',
        name: 'Styled Components',
      },
      {
        id: '3',
        name: 'TypeScript',
      },
    ]
  },
  {
    id: '5',
    image: 'https://github.com/DAVI-REZENDE/reactjs-projects/blob/master/previews/blog-jamstack.png?raw=true',
    title: 'Blog (JAMStack)',
    description: 'This is a JAMStack project that uses Next.js and GraphQL to consume the GraphCMS API, styled by the tailwind library. GraphQL queries were generated automatically by lib codegen',
    github_link: 'https://github.com/DAVI-REZENDE/reactjs-projects/tree/master/jamstack',
    // deploy_link: 'https://discordcloneinterface.netlify.app/',
    tags: [
      {
        id: '1',
        name: 'ReactJS',
      },
      {
        id: '2',
        name: 'Next.js',
      },
      {
        id: '3',
        name: 'TypeScript',
      },
      {
        id: '4',
        name: 'GraphQL',
      },
      {
        id: '5',
        name: 'TailwindCSS',
      },
    ]
  },
]